<template>
    <div class="promo-code" v-show="!submitted">
        <div
            class="promo-code-show"
            @click="expandPromoCode"
            v-if="!promoCodeExpanded"
        >
            <p>
                Mam kod rabatowy
            </p>
        </div>
        <transition name="fade">
            <div class="promo-code-row" v-if="promoCodeExpanded">
                <input
                    ref="input"
                    placeholder="Wpisz kod"
                    type="text"
                    @keydown.enter="submitPromoCode"
                    v-model.trim="promoCodeToken"
                />
                <ActionButton
                    :loading="loading"
                    label="Użyj kodu"
                    color="apple"
                    @click="submitPromoCode"
                />
            </div>
        </transition>
    </div>
</template>
<script>
export default {
    props: {
        selectedItem: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            promoCodeExpanded: false,
            promoCodeToken: '',
            promoCode: {},
            loading: false,
            submitted: false
        }
    },
    computed: {
        currentProduct() {
            return this.selectedItem.uuid || this.$route.params.uuid
        }
    },
    methods: {
        expandPromoCode() {
            this.promoCodeExpanded = true
            this.$nextTick(() => {
                this.$refs.input.focus()
            })
        },
        submitPromoCode() {
            if (this.loading || !this.promoCodeToken) {
                return
            }
            this.loading = true
            this.$api
                .get(`v1/vod/check/${this.promoCodeToken.toLowerCase()}`)
                .then(({ data }) => {
                    if (
                        !data.products.includes(this.currentProduct) ||
                        !data.is_active
                    ) {
                        this.$Notif.error(
                            'Podany kod promocyjny jest nieprawidłowy'
                        )
                    } else {
                        this.$Notif.success('Kod promocyjny został przyjęty')
                        this.$store.commit('setPromoCode', {
                            uuid: this.currentProduct,
                            code: data
                        })
                        this.$emit('update')
                        this.submitted = true
                    }
                })
                .catch(error => {
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.loading = false
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.promo-code {
    margin-top: 1rem;
}
.promo-code-show {
    color: $accent-apple;
    font-size: 1.5rem;
    font-family: $input-family;
    display: flex;
    p {
        margin: 0;
        cursor: pointer;
        transition: $ease;
        &:hover {
            transform: $translateY;
        }
    }
}
.promo-code-row {
    display: flex;
    margin-top: 0.5rem;

    input {
        background: transparent;
        border: none;
        outline: none;
        color: var(--color);
        font-size: 1.5rem;
        font-family: $input-family;
    }
}
@media (max-width: 1000px) {
    .promo-code {
        margin-top: 0.5rem;
        margin-bottom: -1.5rem;
    }
    .promo-code-show {
        font-size: 1.2rem;
    }
}
.promo-code-row {
    input {
        font-size: 1.2rem;
    }
}
</style>
